import { TextField } from '@mui/material';
import { useMemo, useState } from 'react';
import { StoneXLabeledItem } from '..';

interface StoneXTextFieldProps {
  id?: string;
  label?: string;
  type?: any;
  defaultValue?: any;
  min?: number;
  max?: number;
  maxLength?: number;
  step?: number;
  name?: string;
  value?: any;
  placeholder?: any;
  fullWidth?: boolean;
  width?: 'small' | string | number;
  disabled?: boolean;
  showRequired?: boolean;
  multiline?: boolean;
  minRows?: string | number;
  maxRows?: string | number;
  error?: string;
  helperText?: string;
  onChange?: (event: any) => void;
  onUpdate?: (value: string) => void;
  onBlur?: (event: any) => void;
}

export function StoneXTextField(props: StoneXTextFieldProps) {

  const [touched, setTouched] = useState(false);

  const width = useMemo(() => {

    if (props.width === 'small') {
      return '180px';
    }

    if (props.fullWidth) {
      return '100%';
    }

    return props.width ?? '250px';

  }, [props.width, props.fullWidth]);

  function onChangeInternal(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    props.onChange && props.onChange(event);
    props.onUpdate && props.onUpdate(event.target.value);
  }

  function onBlurInternal(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setTouched(true);
    props.onBlur && props.onBlur(event);
  }

  return (
    <StoneXLabeledItem label={props.label} width={width} fullWidth={props.fullWidth} showRequired={props.showRequired}>
      <TextField
         sx={{
          '& .MuiInputBase-input': { 
            textAlign: props.type === 'price' || props.type == 'volume' ? 'right' : undefined, 
          },
          '& .MuiInputBase-root': {
            width: width,
            '& textarea': {
              resize: 'vertical', // Allows resizing both horizontally and vertically
              overflow: 'auto', // Allows scrolling if the content exceeds the size
            },
          },
          '& .MuiFormHelperText-root': { marginLeft: 0 },
        }}
        InputProps={{ inputProps: { min: props.min, max: props.max, maxLength: props.maxLength, step: props.step } }}
        id={props.id}
        error={touched && !!props.error}
        helperText={touched ? (props.error ?? props.helperText) : props.helperText}
        disabled={props.disabled}
        value={props.value}
        onChange={onChangeInternal}
        onBlur={onBlurInternal}
        type={props.type}
        name={props.name}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        multiline={props.multiline}
        minRows={props.minRows} 
        maxRows={props.maxRows}
      />
    </StoneXLabeledItem>
  );
}
